import { render } from "./LoadIcon.vue?vue&type=template&id=152988ca&scoped=true"
import script from "./LoadIcon.vue?vue&type=script&lang=js"
export * from "./LoadIcon.vue?vue&type=script&lang=js"

import "./LoadIcon.vue?vue&type=style&index=0&id=152988ca&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152988ca"]])

export default __exports__